import React, { useContext, useReducer, useMemo, createContext } from 'react'
import * as ga from '@lib/ga'
import { DEFAULT_DATE_POSTED } from '@src/constants'

const SearchContext = createContext(null)

const initialState = {
  searchTerm: '',
  loading: false,
  filter: false,
  mobileAlert: false,
  autoApply: false,
  salaryMin: 0,
  mobileScrollDown: false,
  filterStates: {
    contract: false,
    fullTime: false,
    hybrid: false,
    onsite: false,
    partTime: false,
    fullRemote: false,
    remoteOptional: false,
    intern: false,
    junior: false,
    midLevel: false,
    senior: false,
    executive: false,
    remoteFirst: false,
    missionDriven: false,
    flexibleHours: false,
    workFromAnywhere: false,
    datePosted: DEFAULT_DATE_POSTED,
  },
  location: {
    formatted_address: '',
    regions: {
      region: '',
      country: '',
      area: '',
    },
    coordinate: {
      lat: '',
      lon: '',
    },
  },
}

function reducer(state, action) {
  switch (action.type) {
    case 'setSalaryMin':
      return {
        ...state,
        salaryMin: action.payload,
      }
    case 'updateSearch':
      ga.event({
        action: 'search',
        params: {
          search_term: action.payload,
        },
      })
      return {
        ...state,
        searchTerm: action.payload,
      }
    case 'updateLocation':
      return {
        ...state,
        location: { ...action.payload },
      }
    case 'setLoading':
      return {
        ...state,
        loading: action.payload,
      }
    case 'setFilter':
      return {
        ...state,
        filter: action.payload,
      }
    case 'setFilterStates':
      return {
        ...state,
        filterStates: handleFilterUpdate(action.payload),
      }
    case 'resetSearch':
      return {
        ...state,
        searchTerm: '',
      }
    case 'setAlertVisibility':
      if (action.payload === true) {
        return {
          ...state,
          autoApply: false,
          mobileAlert: action.payload,
        }
      }

      return {
        ...state,
        mobileAlert: action.payload,
      }
    case 'setAAVisibility':
      console.log('payload: ', action.payload)
      if (action.payload === true) {
        return {
          ...state,
          mobileAlert: false,
          autoApply: action.payload,
        }
      }

      return {
        ...state,
        autoApply: action.payload,
      }
    case 'setMobileAlert':
      return {
        ...state,
        mobileAlert: action.payload,
      }
    case 'setMobileScroll':
      return {
        ...state,
        mobileScrollDown: action.payload,
      }
    default:
      throw new Error()
  }
}

const handleFilterUpdate = (filters) => {
  const newFilters = { ...filters }

  if (!filters?.fullRemote && !filters?.hybrid && !filters?.onsite) {
    newFilters.fullRemote = true
    newFilters.remoteOptional = true
    newFilters.hybrid = true
    newFilters.onsite = true
  }

  if (!filters?.fullTime && !filters?.partTime && !filters?.contract) {
    newFilters.fullTime = true
    newFilters.partTime = true
    newFilters.contract = true
  }

  if (newFilters.fullRemote === false) {
    newFilters.remoteOptional = false
  }

  if (
    !newFilters.intern &&
    !newFilters.junior &&
    !newFilters.midLevel &&
    !newFilters.senior &&
    !newFilters.executive
  ) {
    newFilters.intern = true
    newFilters.junior = true
    newFilters.midLevel = true
    newFilters.senior = true
    newFilters.executive = true
  }

  return newFilters
}

export function SearchProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)

  let contextValue = useMemo(() => {
    return { state, dispatch }
  }, [state, dispatch])

  return (
    <SearchContext.Provider value={contextValue}>
      {children}
    </SearchContext.Provider>
  )
}

export function useJobSearch() {
  let theContext = useContext(SearchContext)
  if (theContext === null) {
    return {
      state: initialState,
      dispatch: () => {},
    }
  }
  return theContext
}
